import React from 'react';
import { NavLink } from 'react-router-dom';

type CustomToggleProps = {
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

const CustomToggle = React.forwardRef<HTMLAnchorElement, CustomToggleProps>(
  ({ children, onClick }, ref) => (
    <NavLink
      to=""
      ref={ref}
      className="text-900 d-flex align-items-center navLinkForceColor"
      style={{ color: 'unset', textDecoration: 'none' }}
      onClick={e => {
        e.preventDefault();
        onClick?.(e);
      }}
    >
      {children}
    </NavLink>
  )
);

CustomToggle.displayName = 'CustomToggle';

export default CustomToggle;
